import React from "react";
import { Flex } from "@chakra-ui/react";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const GrantCompletionBadge = _ref => {
  let {
    completed,
    milestones
  } = _ref;
  const filteredMilestones = milestones.filter(milestone => !milestone.isGrantUpdate);
  const completedCount = filteredMilestones.reduce((acc, cur) => acc += +!!cur.completed, 0);
  let percent = 0;
  if (milestones.length === 0) {
    percent = completed ? 100 : 0;
  } else {
    percent = filteredMilestones.length > 0 ? Math.floor(completedCount / filteredMilestones.length * 100) : 0;
  }
  return /*#__PURE__*/_jsx(Flex, {
    bg: percent === 100 ? "green.200" : "gray.200",
    borderRadius: "3xl",
    px: 3,
    py: 1,
    mb: "1px",
    alignItems: "center",
    children: /*#__PURE__*/_jsxs("small", {
      children: [percent, "% Complete"]
    })
  });
};